import { useState, useEffect } from 'react';
import { supabase } from '../config/supabase';

export const useAdmissionForm = () => {
  const [content, setContent] = useState('');
  const [brochureFile, setBrochureFile] = useState(null);
  const [admissionLink, setAdmissionLink] = useState('');
  const [loading, setLoading] = useState(true);
  const [admissionData, setAdmissionData] = useState(null);
  const [alert, setAlert] = useState({ show: false, message: '', type: '' });
  const [currentBrochureLink, setCurrentBrochureLink] = useState(null);

  const fetchAdmissionContent = async () => {
    try {
      const { data, error } = await supabase
        .from('admissions')
        .select('content, brochure_link, admission_link')
        .single();
      
      if (error) throw error;
      setContent(data?.content || '');
      setAdmissionLink(data?.admission_link || '');
      setCurrentBrochureLink(data?.brochure_link || null);
      setAdmissionData(data);
    } catch (err) {
      console.error('Error fetching admission content:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleFileUpload = async (file) => {
    try {
      const fileExt = file.name.split('.').pop();
      const fileName = `${Math.random()}.${fileExt}`;
      const filePath = `${fileName}`;

      const { error: uploadError } = await supabase.storage
        .from('admission-brochures')
        .upload(filePath, file);

      if (uploadError) throw uploadError;

      const { data: { publicUrl } } = supabase.storage
        .from('admission-brochures')
        .getPublicUrl(filePath);

      return publicUrl;
    } catch (err) {
      console.error('Error uploading file:', err);
      throw err;
    }
  };

  const saveAdmissionContent = async () => {
    try {
      let brochureLink = currentBrochureLink;
      if (brochureFile) {
        brochureLink = await handleFileUpload(brochureFile);
      }

      const { error } = await supabase
        .from('admissions')
        .upsert({ 
          id: 1, 
          content, 
          brochure_link: brochureLink, 
          admission_link: admissionLink 
        }, { onConflict: 'id' });
      
      if (error) throw error;
      setCurrentBrochureLink(brochureLink);
      showAlert('Perubahan berhasil disimpan!', 'success');
    } catch (err) {
      console.error('Error saving admission content:', err);
      showAlert('Gagal menyimpan perubahan. Silakan coba lagi.', 'error');
    }
  };

  const showAlert = (message, type) => {
    setAlert({ show: true, message, type });
    setTimeout(() => setAlert({ show: false, message: '', type: '' }), 5000);
  };

  useEffect(() => {
    fetchAdmissionContent(); 
  }, []);

  return {
    content,
    setContent,
    brochureFile,
    setBrochureFile,
    admissionLink,
    setAdmissionLink,
    loading,
    admissionData,
    alert,
    currentBrochureLink,
    saveAdmissionContent
  };
};
